export default{
  getUrlCode(name) {
    return (
      decodeURIComponent(
        (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
          'http://localhost:8088?id=111&latitude=109.88&longitude=222'
        ) || [, ''])[1].replace(/\+/g, '%20')
      ) || null
    )
  }
}



// WEBPACK FOOTER //
// ./src/util/default.js